import { render } from "./CorrectWord.vue?vue&type=template&id=2d8ef197"
import script from "./CorrectWord.vue?vue&type=script&lang=ts"
export * from "./CorrectWord.vue?vue&type=script&lang=ts"
script.render = render

export default script